import React from "react";
import { UpcomingEventStyled } from "./styled";
import { useTranslation } from "react-i18next";
import { IMG_PATH } from "utils/constants/imgPath";

const UpcomingEvent = ({
  name_en,
  name_th,
  short_description_en,
  short_description_th,
  thumbnail_img,
}) => {
  const { i18n } = useTranslation(["common"]);
  return (
    <UpcomingEventStyled>
      <div className="uc_left_col">
        <img
          className="ue_img"
          alt="music hall"
          src={
            thumbnail_img
              ? IMG_PATH + thumbnail_img
              : "/assets/images/mockups/mockup-item-hall.jpg"
          }
        />
      </div>
      <div className="uc_right_col">
        <div className="ue_title">
          {i18n.language === "en" ? name_en : name_th}
        </div>
        <div className="ue_detail">
          {i18n.language === "en" ? short_description_en : short_description_th}
        </div>
      </div>
    </UpcomingEventStyled>
  );
};

export default UpcomingEvent;
